import React from 'react';
import { get } from 'lodash';
import Select from '../Select';

const EditableSelect = ({ dataKey, rowData, columnData: { options, onChange, validate } }) => {
  const value = get(rowData, dataKey);
  return <Select options={options} value={value} onChange={onChange} error={validate?.(value)} usePortal />;
};

export default EditableSelect;
